<div class="popupGeneric" [class.fullScreeMode]="isfullScreeMode" [ngClass]="customStyle">
    <div class="popupGeneric-wrapper" [class.fullHeight]="fullHeight" [class]="'popupGeneric-wrapper_'+size+'Size'">

        @if (!!title) {
        <div class="popupGeneric-wrapper-header">

            <epmax-typo color="primary" [weight]="weight" class="hiddenXsMode headerTitle">{{title|translate}} {{subTitle|translate}} </epmax-typo>
            <div>
                @if (!!buttonHeader) {
                <ng-container >
                    <epmax-icon [size]="20" [color]="'brand'" [name]="buttonHeader" (click)="onButtonHeaderClick()" [title]="buttonHeaderTitle | translate"></epmax-icon>
                </ng-container>
            }
            @if(showFullscreenButton){
                <ng-container >
                    <epmax-icon [size]="20" [color]="'secondary'"
                                [name]="!isfullScreeMode ? 'open_in_full' : 'close_fullscreen'" (click)="fullScreeToggle()"
                                class="hiddenXsMode"></epmax-icon>
                </ng-container>}
                <button class="close-button" (click)="dismiss()">
                    <epmax-icon [size]="20" [color]="'muted'" [name]="'close'"></epmax-icon>
                </button>

            </div>
            <epmax-typo class="headerTitleXsMode" [weight]="700" [name]="'h5'">{{title|translate}} {{subTitle|translate}} </epmax-typo>

        </div>
        }
        <div class="popupGeneric-wrapper-container">
            <ng-container #template></ng-container>

        </div>
        @if (isBusy) {
        <div class="overlay-loader">
            <epmax-loader />
        </div>
        }

        @if (viewFooter) {
        <div class="popupGeneric-wrapper-footer" [class.flex-column-reverse]="size == 'xs'">
            
            @if (size!=='xs') {
                <div class="flex-1 spacer-for-popup-btn hide-in-mobile"></div>
            }

            @for(btn of otherButtons;track $index){
            <epmax-button [style]="btn.style || 'filled'" [style.order]="btn.order || 'unset'" [data-automation-id]="btn.automationId" [disabled]="isBusy" [type]="btn.type" [label]="btn.label | translate"
                          (click)="btn.event()" size="medium" class="otherButton-order other-btn-popup hide-in-mobile">
            </epmax-button>
            }

            @if(!!closeButtonText){
                <epmax-button [data-automation-id]="'popup-dismiss'" [type]="closeButtonColor || 'secondary'" [disabled]="isBusy" [label]="closeButtonText|translate "
                              (click)="dismiss()" size="medium" type='secondary' class="close-btn-popup hide-in-mobile">
                </epmax-button>
        }
        @if(!!submitButtonText){
            <epmax-button [data-automation-id]="'popup-submit'" [type]="submitButtonColor || 'primary'" [label]="submitButtonText|translate"
                          (click)="onSubmit()" size="medium" class="other-btn-popup flex-1-in-mobile">
            </epmax-button>
        }
        </div>
        }

    </div>
</div>
